import clsx from 'clsx';
import React, { CSSProperties, useMemo, useState } from 'react';

import MenuLink, { MenuLinkTypes } from './MenuLink';

interface ExpandableMenuProps {
  children?: React.ReactNode;
  isPro?: boolean;
  menuSize?: number;
  name: string;
  showSeparator?: boolean;
  onClickCapture?: () => void;
}

interface MenuHeightCSS extends CSSProperties {
  '--menu-height': string;
}

const MENU_ITEM_HEIGHT = 37;
const SPECIAL_PROJECTS_HEIGHT = 77;

const ExpandableMenu = ({
  children,
  isPro,
  menuSize,
  name,
  onClickCapture,
  showSeparator,
}: ExpandableMenuProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const largeOpenMenuHeight = MENU_ITEM_HEIGHT * menuSize + SPECIAL_PROJECTS_HEIGHT;
  const styleProps = useMemo(() => {
    if (isPro) {
      return {
        '--menu-height': `${isMenuOpen ? largeOpenMenuHeight : 0}px`,
        maxHeight: 'var(--menu-height)',
      } as MenuHeightCSS;
    } else {
      return {};
    }
  }, [isMenuOpen, isPro, largeOpenMenuHeight]);

  return (
    <div
      className={clsx({
        'border-0 border-b border-solid border-grayscale-gray pb-2': showSeparator,
      })}
    >
      <MenuLink
        name={name}
        as={MenuLinkTypes.Button}
        isMenuOpen={isMenuOpen}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        onClickCapture={onClickCapture}
        isPro={isPro}
      />
      <div
        className={clsx('overflow-hidden transition-all duration-500 ease-in-out', {
          'invisible !max-h-0': !isMenuOpen,
        })}
        style={styleProps}
      >
        <div className="mb-16 ml-2 mt-20">{children}</div>
      </div>
    </div>
  );
};

export default ExpandableMenu;
